import Base from './base'

export default class Activities extends Base {
  allForUserId(userId) {
    return this.api.get(`people/${userId}/activities.json`)
  }

  allForAccountId(accountId) {
    return this.api.get(`accounts/${accountId}/activities.json`)
  }

  success(userId) {
    return this.api.post(`people/${userId}/successes.json`)
  }
}
